<template>
  <stats-card v-loading="loading"
              :sub-title="$t('topUpsSumsStatsCard.subTitle')"
              :title="total | money"
              type="danger"
              icon="tim-icons icon-wallet-43">
    <div slot="footer">
      {{$t('topUpsSumsStatsCard.footer')}} {{current_month | money}}
    </div>
  </stats-card>
</template>
<script>
  import StatsCard from 'src/components/Cards/StatsCard';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'top-up-sums',
    components: {
      StatsCard,
    },
    methods: {
      ...mapActions(['LoadTopUpSumsStats']),
    },
    computed: {
      ...mapState({
        loading: state => state.top_up_stats.loading,
      }),
    },
    mounted() {
      this.LoadTopUpSumsStats();
    },
    data() {
      return {
        total: 0,
        current_month: 0,
      };
    },
    watch: {
      "$store.state.top_up_stats.data"(data) {
        this.total = data.total;
        this.current_month = data.current_month;
      }
    }
  };
</script>
